var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFulda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.67 71.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e,.f{stroke-width:0px;}.e{fill:#e1251b;}.f{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 283.67,
    height: 71.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M30.73,43c2.13-2.52,4.06-5.46,5.57-8.79,2.05-4.53,3.33-9.79,3.33-15.95H14.28v33.48c2.44-.27,4.18-.81,6-1.55,4.03-1.63,7.66-3.91,10.45-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M42.57,43.54c1.82-2.01,3.37-4.26,4.68-6.62,2.75-4.99,4.92-10.95,4.92-18.66h-7.51c-.15,3.99-.85,8.05-2.09,11.88-1.39,4.3-3.48,8.28-6.27,11.69-4.26,5.23-10.18,9.02-17.81,10.18-2.36.35,4.88.08,7.2-.11,4.14-.39,7.63-1.59,10.61-3.29,2.4-1.39,4.49-3.1,6.27-5.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M59.64,18.27c-.5,12.46-6.12,24.96-17.07,30.77-1.9,1.01-3.99,1.82-6.27,2.4-.89.23-1.86.42-2.86.58-1.39.19.58.19,2.86.11,1.63-.04,3.41-.15,4.37-.23.66-.08,1.28-.15,1.9-.27,14.63-2.44,24.54-16.95,24.54-33.36h-7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M70.6,41.84c-1.67,2.21-3.83,4.03-6.04,5.65-2.4,1.78-5.34,3.56-8.79,4.26h35.34v-11.07h12.93v-8.13h-12.93v-5.96h14.86v-8.32h-27.48c-.35,8.51-2.63,16.68-7.89,23.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M133.69,38.47c0,1.51-.5,3.41-1.16,4.37-1.08,1.7-4.14,2.51-6.81,1.82-1.24-.35-2.52-1.47-2.98-2.6-.46-1.04-.77-2.09-.77-3.6v-20.2h-13.35v20.2c0,2.98.11,5.92,1.63,8.51.97,1.7,2.86,3.33,4.76,4.14,5.61,2.36,18.46,2.55,24.5.39,2.05-.73,4.18-2.21,5.3-3.87,1.43-2.17,2.17-5.5,2.17-9.17v-20.2h-13.27v20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M243.84,39.25h-4.76l4.76-10.8.12-.31,4.65,11.11h-4.76ZM253.01,18.27h-16.64l-15.17,30.77-1.35,2.71h13.66l2.21-4.88h16.26l2.05,4.88h15.37l-16.37-33.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M206.02,41.45c-1.2,1.16-2.51,1.74-4.1,2.01-1.7.31-3.75.31-6.46.31v-17.42c3.17,0,4.95,0,6.46.27,1.01.16,1.9.47,2.94,1.01,4.18,2.05,4.8,10.37,1.16,13.82M222.44,33.17c-.19-2.01-.62-3.79-1.24-5.38-2.13-5.22-6.66-8.09-12.97-9.02-2.09-.31-4.06-.46-6.31-.5h-20.13v33.48h22.18c3.21,0,5.84-.27,8.4-1.01,2.24-.66,4.18-1.94,5.8-3.25,1.28-1.04,2.28-2.51,3.02-4.26,1.12-2.79,1.55-6.27,1.24-10.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "164.77 18.27 150.95 18.27 150.95 51.75 179.09 51.75 179.09 43 164.77 43 164.77 18.27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulda);
export default __webpack_public_path__ + "static/media/fulda.5b4b390d915b975fe432ecc6690d937c.svg";
export { ForwardRef as ReactComponent };